import blueGrey from '@material-ui/core/colors/blueGrey'
import orange from '@material-ui/core/colors/orange'
import { createMuiTheme } from '@material-ui/core/styles'

export const palette = {
  primary: blueGrey,
  secondary: orange,
}

const baseTheme = createMuiTheme({})
const theme = createMuiTheme({
  palette,
  overrides: {
    MuiGrid: {
      container: {
        marginBottom: '30px',
      },
    },
    MuiPaper: {
      root: {
        marginTop: '8px',
        padding: '8px',
        [baseTheme.breakpoints.up('md')]: {
          padding: '12px',
        },
      },
    },
    MuiAppBar: {
      root: {
        padding: 0,
        margin: 0,
      },
    },
    MuiButton: {
      root: {
        minWidth: '60px',
      },
    },
  },
})

export default theme
